import { TableHeadProps } from "../../types";
import { ColumnHeading, TableHeadActions } from "../index";

export const TableHead = ({
  table,
  sorting,
  flexRender,
  DirectoryActions,
  handleClickOnColumnHead,
}: TableHeadProps) => {
  try {
    const headerGroups = table?.getHeaderGroups();
    if (!headerGroups || !Array.isArray(headerGroups)) {
      return (
        <thead className="table_row_header w-full sticky top-0 h-[48px] z-20  dark:bg-bgtetriary">
          <tr className="w-full cursor-pointer " style={{ height: "49px" }}>
            <th className="whitespace-nowrap sticky right-0 dark:bg-bgtetriary">
              <div className="flex items-center justify-center h-full">
                <p className="text-gray-500">Loading headers...</p>
              </div>
            </th>
          </tr>
        </thead>
      );
    }

    return (
      <thead className="table_row_header w-full sticky top-0 h-[48px] z-20  dark:bg-bgtetriary">
        <tr className="w-full cursor-pointer " style={{ height: "49px" }}>

          {headerGroups.map((headerGroup: any) => {
            return (
              <ColumnHeading
                key={headerGroup.id}
                headerGroup={headerGroup}
                sorting={sorting}
                flexRender={flexRender}
                handleClickOnHead={handleClickOnColumnHead}
              />
            );
          })}

          <th className="whitespace-nowrap sticky right-0 dark:bg-bgtetriary">
            {/* <TableHeadActions DirectoryActions={DirectoryActions} /> */}
          </th>
        </tr>
      </thead>
    );
  } catch (error) {
    console.error('TableHead error:', error);
    return (
      <thead className="table_row_header w-full sticky top-0 h-[48px] z-20  dark:bg-bgtetriary">
        <tr className="w-full cursor-pointer " style={{ height: "49px" }}>
          <th className="whitespace-nowrap sticky right-0 dark:bg-bgtetriary">
            <div className="flex items-center justify-center h-full">
              <p className="text-red-500">Error loading headers</p>
            </div>
          </th>
        </tr>
      </thead>
    );
  }
};

